document.addEventListener("DOMContentLoaded", function () {
  const glossaryLinks = {
    "Detox": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Detox",
    "MSM": "https://www.ncbi.nlm.nih.gov/pubmed/?term=MSM",
    "Inflammation": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Inflammation",
    "Cytokines": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Cytokines",
    "Immune System": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Immune+System",
    "Lymphatic System": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Lymphatic+System",
    "Protozoa": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Protozoa",
    "Pathogen": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Pathogen",
    "Shavegrass": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Shavegrass",
    "Sulfur": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Sulfur",
    "Kidneys": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Kidneys",
    "Myelin": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Myelin",
    "Neurological Symptoms": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Neurological+Symptoms",
    "Atrophy": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Atrophy",
    "Nutrient Absorption": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Nutrient+Absorption",
    "Leaky Gut": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Leaky+Gut",
    "Biofilm": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Biofilm",
    "CNS": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Cns",
    "DMSO": "https://www.ncbi.nlm.nih.gov/pubmed/?term=Dmso"
    // Add more glossary terms here if needed
  };

  const tagFilter = ['SCRIPT', 'STYLE', 'IFRAME', 'A'];

  function walkAndLink(node) {
    if (node.nodeType === 3) {
      const parent = node.parentElement;
      if (tagFilter.includes(parent.tagName)) return;

      let replaced = node.nodeValue;
      for (const [term, url] of Object.entries(glossaryLinks)) {
        const safeTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`\\b(${safeTerm})\\b`, 'gi');
        replaced = replaced.replace(regex, `<a href="${url}" target="_blank">$1</a>`);
      }

      if (replaced !== node.nodeValue) {
        const span = document.createElement('span');
        span.innerHTML = replaced;
        parent.replaceChild(span, node);
      }

    } else if (node.nodeType === 1 && !tagFilter.includes(node.tagName)) {
      for (let child of Array.from(node.childNodes)) {
        walkAndLink(child);
      }
    }
  }

  walkAndLink(document.body);
});
